



















import Vue from 'vue'

export default Vue.extend({
  name: 'ExcDropdownTriangle',
  props: {
    direction: {
      validator: v => v === 'top' || v === 'bottom',
      default: 'top',
    },
  },
})
